import React, { Component } from "react";
import { confirmAlert } from "react-confirm-alert";
import { toast } from "react-toastify";
import { getCardCodes, deleteCardCode } from "../services/cardCodeService";
import auth from "../services/authService";
import Spinner from "./common/spinner";
import NotFound from "./notFound";
import Alert from "./common/alert";
import AddButton from "./common/addButton";
import CardCodesTable from "./cardCodesTable";

class CardCodes extends Component {
  state = {
    ccodes: [],
    loading: false,
  };

  async componentDidMount() {
    this.setState({ loading: true });
    const ccodes_response = await getCardCodes();
    this.setState({ loading: false });
    const { data: ccodes } = ccodes_response.data;
    this.setState({ ccodes });
  }

  handleDelete = async (ccode) => {
    const originalCardCodes = this.state.ccodes;
    const ccodes = originalCardCodes.filter((c) => c._id !== ccode._id);
    this.setState({ ccodes });

    try {
      confirmAlert({
        customUI: ({ onClose }) => {
          return (
            <Alert
              name="Card Code"
              onClose={() => {
                this.setState({ ccodes: originalCardCodes });
                onClose();
              }}
              onDelete={async () => {
                await deleteCardCode(ccode._id);
                onClose();
              }}
            />
          );
        },
      });
    } catch (ex) {
      if (ex.response && ex.response.status === 404)
        toast("This Card Code has already been deleted.");

      this.setState({ ccodes: originalCardCodes });
    }
  };

  getPagedData = () => {
    const { ccodes } = this.state;

    return { data: ccodes };
  };

  render() {
    const { loading } = this.state;
    const { data: ccodes } = this.getPagedData();
    const { isAdmin } = auth.getCurrentUser();
    if (loading) return <Spinner message="loading page data..." />;
    return isAdmin ? (
      <React.Fragment>
        <AddButton link="/card-codes/new" value="Add Card Code" />
        <CardCodesTable
          ccodes={ccodes}
          onDelete={this.handleDelete}
          message="Card Codes"
        />
      </React.Fragment>
    ) : (
      <NotFound />
    );
  }
}

export default CardCodes;
